var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputRef",staticStyle:{"border":"1px solid #DDD","border-radius":"5px"},attrs:{"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }